/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselNextPort
 */
export interface VesselNextPort {
    /**
     * 
     * @type {any}
     * @memberof VesselNextPort
     */
    portUnLocationCode?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselNextPort
     */
    eta?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselNextPort
     */
    probability?: any | null;
}

/**
 * Check if a given object implements the VesselNextPort interface.
 */
export function instanceOfVesselNextPort(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselNextPortFromJSON(json: any): VesselNextPort {
    return VesselNextPortFromJSONTyped(json, false);
}

export function VesselNextPortFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselNextPort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portUnLocationCode': !exists(json, 'port_un_location_code') ? undefined : json['port_un_location_code'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'probability': !exists(json, 'probability') ? undefined : json['probability'],
    };
}

export function VesselNextPortToJSON(value?: VesselNextPort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'port_un_location_code': value.portUnLocationCode,
        'eta': value.eta,
        'probability': value.probability,
    };
}

